
import { mapActions } from "vuex"
import cardClick from "~/mixins/cardClick"
import filters from "~/mixins/filters"
export default {
  mixins: [filters, cardClick],
  data() {
    return {
      sliderInit: false
    };
  },
  mounted() {
    // this.$refs.slider_small_desc.addEventListener('contextmenu', event => event.preventDefault());
  },
  props: {
    offer: Object
  },
  methods: {
    ...mapActions({
      closeModal: "modal/modal-main/closeModal"
    }),
    preventLink(e) {
      e.preventDefault();
    }
  },
  computed: {
    src() {
      return require(`~/assets/img/catalog/catalog-item-gap.webp`);
     
    }
  },
  watch: {
    $route() {
      this.closeModal();
    },
    sliderInit(value) {
      value &&
        this.$refs.slider_small_desc.addEventListener("contextmenu", event =>
          event.preventDefault()
        );
    }
  }
};
